import api from "./api";

/**
 * Disruption notices ("Notify affected customers", phase 1). The server finds
 * the affected bookings, scopes everything to the reader's branches and
 * refuses providers; this only moves data.
 */

/** GET /business/disruption-notices/types — scope fields, placeholders, actions, default AR/EN copy. */
export const fetchNoticeTypes = async () => (await api.get("/business/disruption-notices/types")).data.data;

/** POST /business/disruption-notices/preview — { bookings, counts }. */
export const previewNotice = async (type, scope) =>
  (await api.post("/business/disruption-notices/preview", { type, scope })).data.data;

/**
 * POST /business/disruption-notices — queued. The Idempotency-Key belongs to
 * the wizard's one send attempt, so a retry after a dropped connection sends once.
 */
export const sendNotice = async (payload, idempotencyKey) =>
  (
    await api.post("/business/disruption-notices", payload, {
      headers: { "Idempotency-Key": idempotencyKey },
    })
  ).data;

/** GET /business/disruption-notices — { data, meta }. */
export const fetchNotices = async ({ page = 1, type = "", branchId = "" } = {}) => {
  const params = { page, per_page: 20 };
  if (type) params.type = type;
  if (branchId) params.branch_id = branchId;
  return (await api.get("/business/disruption-notices", { params })).data;
};

/** GET /business/disruption-notices/{id} — { data: { notice, recipients }, meta }. */
export const fetchNotice = async (id, { page = 1, action = "" } = {}) => {
  const params = { page, per_page: 50 };
  if (action) params.action = action;
  return (await api.get(`/business/disruption-notices/${id}`, { params })).data;
};

/**
 * A link into the wizard with the type and scope prefilled — used by the
 * shortcuts (time off, closures, provider status, diary). Arrays are
 * comma-joined; `hours` is JSON.
 */
export const noticeWizardPath = (type, scope = {}) => {
  const params = new URLSearchParams();
  if (type) params.set("type", type);
  Object.entries(scope).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (key === "hours") params.set(key, JSON.stringify(value));
    else params.set(key, Array.isArray(value) ? value.join(",") : String(value));
  });
  return `/notices/new?${params.toString()}`;
};
